export default __webpack_public_path__ + "static/media/emerald.a6395f8f.svg";